var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompanyInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_7_19749)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.35462 7.0864C4.35462 3.57612 7.60679 0.730469 11.6185 0.730469H40.6742C44.686 0.730469 47.9382 3.57612 47.9382 7.0864V45.222C49.944 45.222 51.5701 46.6448 51.5701 48.4C51.5701 50.1551 49.944 51.5779 47.9382 51.5779H34.4103C33.858 51.5779 33.4103 51.1302 33.4103 50.5779V42.044C33.4103 40.2889 31.7842 38.8661 29.7783 38.8661H22.5144C20.5085 38.8661 18.8825 40.2889 18.8825 42.044V50.5779C18.8825 51.1302 18.4347 51.5779 17.8825 51.5779H4.35462C2.34874 51.5779 0.722656 50.1551 0.722656 48.4C0.722656 46.6448 2.34874 45.222 4.35462 45.222V7.0864ZM15.2505 10.2644H22.5144V16.6203H15.2505V10.2644ZM22.5144 22.9762H15.2505V29.3322H22.5144V22.9762ZM29.7783 10.2644H37.0423V16.6203H29.7783V10.2644ZM37.0423 22.9762H29.7783V29.3322H37.0423V22.9762Z",
    fill: "#5063EE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_7_19749",
    x: 0.722656,
    y: 0.730469,
    width: 50.8477,
    height: 51.8477,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_7_19749"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyInfo);
export default __webpack_public_path__ + "static/media/companyInfo.7ea48be31aa3e009238afce02f3fd212.svg";
export { ForwardRef as ReactComponent };